import React, { createContext, useContext, useState, useMemo } from 'react';
import enLocale from '../locales/en.json';

const LOCALE_MAP = {
    English: enLocale,
};

const DEFAULT_LOCALE = 'English';

const ConstantsContext = createContext();

const flattenLocale = (localeData = {}) => {
    const {
        global = {},
        navigation = {},
        dashboard = {},
        dropdown = {},
        login = {},
    } = localeData || {};

    return {
        ...global,
        ...navigation,
        ...dashboard,
        global,
        navigation,
        dashboard,
        dropdown,
        login,
    };
};

export const ConstantsProvider = ({ children }) => {
    const [locale, setLocale] = useState(DEFAULT_LOCALE);
    const constants = useMemo(() => flattenLocale(LOCALE_MAP[locale] || enLocale), [locale]);

    return (
        <ConstantsContext.Provider value={{ ...constants, locale, setLocale }}>
            {children}
        </ConstantsContext.Provider>
    );
};

export const useConstants = () => {
    const context = useContext(ConstantsContext);
    if (!context) {
        return flattenLocale(enLocale);
    }
    return context;
};

export default ConstantsContext;
